import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import RegionalOverviewMap from './components/RegionalOverviewMap';
import QuickNavigationCards from './components/QuickNavigationCards';
import ProjectIntroduction from './components/ProjectIntroduction';

const Homepage = () => {
  return (
    <>
      <Helmet>
        <title>Creative Twinning - Discover Serbia & Montenegro Heritage Trails</title>
        <meta 
          name="description" 
          content="Explore thematic heritage trails across Serbia and Montenegro. Discover cultural sites, natural wonders, and authentic local experiences through our interactive tourism platform." 
        />
        <meta name="keywords" content="Serbia, Montenegro, heritage trails, cultural tourism, Balkans, cross-border travel" />
        <meta property="og:title" content="Creative Twinning - Heritage Trails of Serbia & Montenegro" />
        <meta property="og:description" content="Discover authentic cultural and natural heritage through immersive thematic trails connecting Serbia and Montenegro." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/homepage" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          {/* Hero Section */}
          <HeroSection />
          
          {/* Regional Overview Map */}
          <RegionalOverviewMap />
          
          {/* Quick Navigation Cards */}
          <QuickNavigationCards />
          
          {/* Project Introduction */}
          <ProjectIntroduction />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Homepage;